export default {"src":"/_next/static/media/Logo_Cedars.7b177e51.svg","height":200,"width":1045,"blurWidth":0,"blurHeight":0};